import { createAction } from 'redux-actions';
import {
  createParams,
  validateParams,
  getValueFromObjects,
  getCPRMapping,
  getAddressMappingV2,
  getCustomerAge,
  prepareCommonCreateUpdateResponse,
} from './common';
import Product from './product';
import * as types from '../../constants/Api';
import { appErrorAction } from '../../actions/App';
import { createErrorBody } from '../error';

class TravelService extends Product {
  static TYPE = 'travel';
  static GET_PRICE = 'travel/v1/price';
  static UPDATE_PRICE = 'travel/v1/price';
  static GET_PRICE_AUX_SERVICE = 'product/v1/auxiliaryprice/travel';
  static TRAVEL_PURCHASE = 'travel/v1/purchase';

  static createdTravel = createAction(types.TRAVEL_CREATED);
  static createTravel = createAction(types.TRAVEL_CREATE);
  static updatedTravel = createAction(types.TRAVEL_UPDATED);
  static updateTravel = createAction(types.TRAVEL_UPDATE);
  static preparedTravel = createAction(types.TRAVEL_PREPARED);
  static prepareTravel = createAction(types.TRAVEL_PREPARE);
  static createdGetPriceAuxServiceTravel = createAction(types.TRAVEL_AUX_GET_PRICE_REQUESTED);
  static createGetPriceAuxServiceTravel = createAction(types.TRAVEL_AUX_GET_PRICE_REQUEST);

  constructor() {
    super(
      TravelService.TYPE,
      TravelService.createTravel,
      TravelService.updateTravel,
      TravelService.prepareTravel
    );
    super.prepareCreateUpdateResponse = this.prepareCreateUpdateResponse;
  }
  /**
   * Temporary method, will be deleted once use use the other method
   * @param dispatch
   */
  getPriceAuxiliaryValues(formValues, dispatch) {
    return this.callApiGet(
      TravelService.GET_PRICE_AUX_SERVICE,
      null,
      dispatch
    ).then((response) => {
      return this.getPriceAuxServiceMapping(response);
    });
  }

  /**
   * This method will used to load all aux services for Travel
   * @param dispatch
   */
  getPriceAuxiliaryService(dispatch) {
    dispatch(this.callApiGet(
      TravelService.GET_PRICE_AUX_SERVICE,
      null,
      dispatch
    ).then((response) => {
      return this.getPriceAuxServiceMapping(response);
    }));
  }

  createdTravelAction(payload) {
    return (dispatch) => dispatch(TravelService.createdTravel(payload));
  }

  createTravelAction(mappedParams, actionOnErrors, reqModel, formValues) {
    return (dispatch, getState) => {
      return dispatch(
        this.requestCreateProductV2(
          TravelService.GET_PRICE,
          mappedParams,
          reqModel,
          formValues
        )
      )
        .then((data) => {
          dispatch(this.createdTravelAction(data));
        })
        .catch((data) => {
          return this.handleError(actionOnErrors, data, getState, dispatch);
        });
    };
  }

  updatedTravelAction(payload) {
    return (dispatch) => dispatch(TravelService.updatedTravel(payload));
  }

  updateTravelAction(mappedParams, actionOnErrors, reqModel, formValues) {
    return (dispatch, getState) => {
      return dispatch(
        this.requestCreateProductV2(
          TravelService.UPDATE_PRICE,
          mappedParams,
          reqModel,
          formValues
        )
      )
        .then((data) => {
          dispatch(this.updatedTravelAction(data));
        })
        .catch((data) => {
          return this.handleError(actionOnErrors, data, getState, dispatch);
        });
    };
  }

  createUpdateTravelAction(params, actionOnErrors, values) {
    return (dispatch, getState) => {
      const state = getState();
      const formValues = { ...values, ...state.userData };
      const mappedParams = params
        ? createParams(params, formValues, state)
        : {};
      const errors = params ? validateParams(mappedParams, params) : [];

      if (errors.length > 0) {
        return Promise.reject(createErrorBody('Missing parameters', errors));
      }

      const requestModel = {
        travel: {
          travelLocation: getValueFromObjects(
            'travelLocation',
            mappedParams,
            formValues
          ) || null,
          travelDaysCovered: getValueFromObjects(
            'travelDaysCovered-travel',
            mappedParams,
            formValues
          ) || null,
          travelValue: getValueFromObjects(
            'travelValue-travel',
            mappedParams,
            formValues
          ) || '',
          luggageSumInsuredText: getValueFromObjects(
            'luggageSumInsuredText',
            mappedParams,
            formValues
          ) || '',
          hiredVehicleDeductible: getValueFromObjects(
            'hiredVehicleDeductible',
            mappedParams,
            formValues
          ) || '',
          travelTreatmentSumText: getValueFromObjects(
            'travelTreatmentSumText',
            mappedParams,
            formValues
          ) || '',
          luggageDelayCompensationText: getValueFromObjects(
            'luggageDelayCompensationText',
            mappedParams,
            formValues
          ) || '',
          travelDelayMealCompensationText: getValueFromObjects(
            'travelDelayMealCompensationText',
            mappedParams,
            formValues
          ) || '',
        },
        customer: {
          age: getCustomerAge(mappedParams, formValues),
          birthdate: getValueFromObjects(
            'birthdate',
            mappedParams,
            formValues
          ),
          civilRegistrationNumber: getCPRMapping(mappedParams, formValues),
          totalInsured: getValueFromObjects(
            'totalInsured',
            mappedParams,
            formValues
          ),
          totalInsuredChildren: getValueFromObjects(
            'totalInsuredChildren',
            mappedParams,
            formValues
          ),
          rolePlayerId: getValueFromObjects(
            'rolePlayerId',
            mappedParams,
            formValues
          ),
          postalAddress: getAddressMappingV2(mappedParams, formValues),
        },
        deductible: getValueFromObjects(
          'deductible-travel',
          mappedParams,
          formValues
        ),
        packageText: getValueFromObjects(
          'packageText',
          mappedParams,
          formValues
        ),
      };

      if (state.userData.travel) {
        return dispatch(
          this.updateTravelAction(mappedParams, actionOnErrors, requestModel, {
            ...formValues,
          })
        ).catch(data => {
          return Promise.resolve(data);
        });
      }

      return dispatch(
        this.createTravelAction(mappedParams, actionOnErrors, requestModel, formValues)
      ).catch(data => {
        return Promise.resolve(data);
      });
    };
  }

  createdGetPriceAuxServiceTravelAction(payload) {
    return (dispatch) => dispatch(TravelService.createdGetPriceAuxServiceTravel(payload));
  }
  createGetPriceAuxServiceTravelAction() {
    return (dispatch) => {
      return dispatch(
        this.getPriceAuxiliaryService()
      )
        .then((data) => {
          dispatch(this.createdGetPriceAuxServiceTravelAction(data));
        })
        .catch((data) => {
          dispatch(appErrorAction(data));
          return Promise.reject(data);
        });
    };
  }

  getExcessAmount(formValues, dispatch) {
    return this.getPriceAuxiliaryValues(formValues, dispatch)
      .then((response) => {
        return response.deductible;
      });
  }

  activationDateGetAction(formValues) {
    return super.activationDateGetAction(
      formValues,
      this.getTravelMapping(formValues)
    );
  }

  getActivationDates(formValues) {
    return super.getActivationDates(formValues, this.getTravelMapping(formValues));
  }

  getTravelMapping(formValues, mappedParams = {}) {
    return {
      product: {
        type: TravelService.TYPE,
        travelLocation: getValueFromObjects(
          'travelLocation',
          mappedParams,
          formValues
        ),
        travelDaysCovered: getValueFromObjects(
          'travelDaysCovered-travel',
          mappedParams,
          formValues
        ),
        luggageSumInsuredText: getValueFromObjects(
          'luggageSumInsuredText',
          mappedParams,
          formValues
        ),
        travelValue: getValueFromObjects('travelValue-travel', mappedParams, formValues),
        totalInsured: getValueFromObjects('totalInsured', mappedParams, formValues),
        totalInsuredChildren: getValueFromObjects('totalInsuredChildren', mappedParams, formValues),
        hiredVehicleDeductible: getValueFromObjects('hiredVehicleDeductible', mappedParams, formValues),
      },
    };
  }

  purchase(params, values, actionOnErrors) {
    return (dispatch, getState) => {
      const state = getState();
      const formValues = { ...values, ...state.userData };
      const mappedParams = params ? createParams(params, formValues, state) : {};
      const errors = params ? validateParams(mappedParams, params) : [];

      if (errors.length > 0) {
        return Promise.reject(createErrorBody('Missing parameters', errors));
      }

      const requestModel = {};

      return dispatch(super.purchaseV2(TravelService.TRAVEL_PURCHASE,
        mappedParams, requestModel, formValues, actionOnErrors));
    };
  }

  prepareCreateUpdateResponse(payload, mappedParams, formValues) {
    let response = prepareCommonCreateUpdateResponse.call(this, payload, formValues);
    response = { ...response,
      travelDaysCovered: payload.travelResponse.travelDaysCovered,
      travelValue: payload.travelResponse.travelValue,
      luggageSumInsuredText: payload.travelResponse.luggageSumInsuredText,
      hiredVehicleDeductible: payload.travelResponse.hiredVehicleDeductible,
      travelTreatmentSumText: payload.travelResponse.travelTreatmentSumText,
      luggageDelayCompensationText: payload.travelResponse.luggageDelayCompensationText,
      travelDelayMealCompensationText: payload.travelResponse.travelDelayMealCompensationText,
      KVHX: payload.customerResponse.postalAddress.KVHX,
    };
    return response;
  }
}

export const travelService = new TravelService();
